import * as actionTypes from './constants'

import { getSongDetail, getLyric, getSimiPlaylist, getSimiSong } from "services/player";
import { parseLyric } from 'utils/lrc-parse'


const changeCurrentSongAction = song => ({
    type: actionTypes.CHNAGE_CURRENT_SONG,
    song
})

const changePlayListAction = (playList) => ({
    type: actionTypes.CHANGE_PLAY_LIST,
    playList
})

const changeCurrentSongIndexAction = (index) => ({
    type: actionTypes.CHANGE_CURRENT_SONG_INDEX,
    index
})

const changeLyricListAction = (lyricList) => ({
    type: actionTypes.CHANGE_LYRIC_LIST,
    lyricList
})

export const changeSequenceAction = (sequence) => ({
    type: actionTypes.CHANGE_SEQUENCE,
    sequence
})

export const changeCurrentLyricIndexAction = (currentLyricIndex) => ({
    type: actionTypes.CHANGE_CURRENT_LYRIC_INDEX,
    currentLyricIndex
})

const changeSimiPlaylistAction = (res) => ({
    type: actionTypes.CHANGE_SIMI_PLAYLIST,
    simiPlaylist: res.playlists
})

const changeSimiSongsAction = (res) => ({
    type: actionTypes.CHANGE_SIMI_SONGS,
    simiSongs: res.songs
})

export const changeCurrentIndexAndSongAction = (tag) => {
    return (dispatch, getState) => {
        const playList = getState().getIn(["player", "playList"])
        const sequence = getState().getIn(["player", "sequence"])
        let currentSongIndex = getState().getIn(["player", "currentSongIndex"])

        switch (sequence) {
            case 1: // 随机播放
                let randomIndex = Math.floor(Math.random() * playList.length)
                while (randomIndex === currentSongIndex) {
                    randomIndex = Math.floor(Math.random() * playList.length)
                }
                currentSongIndex = randomIndex
                break;
            default: //循序播放
                currentSongIndex = currentSongIndex + tag
                if (currentSongIndex >= playList.length) {
                    currentSongIndex = 0
                }
                if (currentSongIndex < 0) {
                    currentSongIndex = playList.length - 1
                }
        }

        const currentSong = playList[currentSongIndex]
        dispatch(changeCurrentSongAction(currentSong))
        dispatch(changeCurrentSongIndexAction(currentSongIndex))

        dispatch(getLyricAction(currentSong.id))
    }
}

export const getSongDetailAction = (ids) => {
    return (dispatch, getState) => {
        // 1.根据ids查找playlist中是否已存在该歌曲
        const playList = getState().getIn(["player", "playList"])
        const songIndex = playList.findIndex(song => song.id === ids)

        // 2.判断是否找到歌曲
        let song = null
        if (songIndex !== -1) {  //在播放列表中找到歌曲
            dispatch(changeCurrentSongIndexAction(songIndex))
            song = playList[songIndex]
            dispatch(changeCurrentSongAction(song))

            // 3.请求该歌曲歌词 
            dispatch(getLyricAction(song.id))
        } else { //没有在播放列表中找到歌曲
            getSongDetail(ids).then(res => {
                song = ''
                if (!song) return

                // 1.将请求的到的歌曲添加到播放列表中
                const newPlayList = [...playList]
                newPlayList.push(song)

                // 2.更新redux中的值
                dispatch(changePlayListAction(newPlayList))
                dispatch(changeCurrentSongIndexAction(newPlayList.length - 1))
                dispatch(changeCurrentSongAction(song))

                // 3.请求该歌曲歌词 
                dispatch(getLyricAction(song.id))
            })
        }
    }
}

export const getLyricAction = (id) => {
    return dispatch => {
        getLyric(id).then(res => {
            const lyric = res.lrc.lyric
            const lyricList = parseLyric(lyric)
            dispatch(changeLyricListAction(lyricList))
        })
    }
}

export const getSimiPlaylistAction = () => {
    return (dispatch, getState) => {
        const id = getState().getIn(["player", "currentSong"]).id;
        if (!id) return;

        getSimiPlaylist(id).then(res => {
            dispatch(changeSimiPlaylistAction(res));
            console.log(res);
        })
    }
}

export const getSimiSongAction = () => {
    return (dispatch, getState) => {
        const id = getState().getIn(["player", "currentSong"]).id;
        if (!id) return;

        getSimiSong(id).then(res => {
            dispatch(changeSimiSongsAction(res));
            console.log(res);
        })
    }
}